export const getModifiedObject = (array, object) => {
  return !array.find(
    x => Object.entries(x).toString() === Object.entries(object).toString(),
  )
}
